import GATSBY_COMPILED_MDX from "/home/runner/work/capsulecrm.com/capsulecrm.com/src/mdxPages/legals/terms/index.mdx";
import * as React from "react";
import {graphql} from "gatsby";
import {Link} from "@zestia/gatsby-plugin-react-i18next";
import MainLayout from "@/layouts/MainLayout";
import MDXContentWrapper from "@/components/MDXContentWrapper";
import CenteredHero from "@/components/CenteredHero";
import Longform from "@/components/Longform";
import SharedHead from "@/components/SharedHead";
export const Head = props => {
  const {data} = props;
  return React.createElement(SharedHead, Object.assign({}, props, {
    title: data.mdx.frontmatter.title,
    description: data.mdx.frontmatter.summary
  }));
};
function LegalsLayout({data, children}) {
  const LegalsNavigationLink = ({page}) => {
    const {slug, navigation, title} = page.frontmatter;
    return React.createElement(Link, {
      to: slug,
      className: "sidebar-menu__link",
      activeClassName: "sidebar-menu__link--active"
    }, navigation.name ? navigation.name : title);
  };
  const LegalsNavigation = ({pages}) => {
    const topLevelPages = pages.filter(page => page.frontmatter.navigation && page.frontmatter.navigation.parent === null);
    return topLevelPages.map(page => {
      const {slug} = page.frontmatter;
      const subPages = pages.filter(subPage => subPage.frontmatter.navigation && subPage.frontmatter.navigation.parent === slug).map(subPage => React.createElement("li", {
        key: subPage.frontmatter.slug
      }, React.createElement(LegalsNavigationLink, {
        page: subPage
      })));
      return React.createElement("li", {
        key: slug
      }, React.createElement(LegalsNavigationLink, {
        page: page
      }), subPages.length > 0 && React.createElement("ul", {
        className: "sidebar-mega-menu sidebar-mega-menu--active"
      }, subPages));
    });
  };
  return React.createElement(MainLayout, {
    availableSlugs: data.mdx.fields.availableSlugs
  }, React.createElement(CenteredHero, {
    kickerText: "Legal",
    title: data.mdx.frontmatter.title,
    backgroundClass: "pt-15 mb-20 bg-grey-1"
  }), React.createElement("section", {
    className: "container-fluid section-sp--sm row"
  }, React.createElement("div", {
    className: "col-xs-12 col-md-3"
  }, React.createElement("nav", {
    className: "sidebar-menu"
  }, React.createElement("ul", null, React.createElement(LegalsNavigation, {
    pages: data.allMdx.nodes
  })))), React.createElement("div", {
    className: "col-xs-12 col-md-9 md:pl-8"
  }, React.createElement(Longform, null, React.createElement(MDXContentWrapper, null, children)))));
}
export const query = graphql`
  query ($language: String, $id: String!) {
    ...Locales
    allMdx(
      sort: { frontmatter: { navigation: { sort_order: ASC } } }
      filter: {
        fields: {
          lang: { eq: $language }
          path: { regex: "/(mdxPages/legals)/" }
        }
      }
    ) {
      nodes {
        frontmatter {
          title
          slug
          navigation {
            name
            parent
            sort_order
          }
        }
      }
    }
    mdx(id: { eq: $id }) {
      fields {
        availableSlugs {
          lang
          slug
        }
      }
      frontmatter {
        title
        summary
      }
      body
      id
    }
  }
`;
LegalsLayout
export default function GatsbyMDXWrapper(props) {
  return React.createElement(LegalsLayout, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
